import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

class TracerouteSubtest extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes
    } = this.props;

    switch (subtest) {
      case "traceroute4":
      case "traceroute6":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_target")}
              </Typography>
              <Typography className={classes.t_tar_no}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].target}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_no_of_hops")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].numberofhops}
              </Typography>
            </Grid>
          </Grid>
        );
      case "cabledata":
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_test_duration2").toUpperCase()}
              </Typography>
              <Typography className={classes.t_tar_no}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].duration}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.bottomGrid}>
              <Typography className={classes.t_tar_text}>
                {translate("result_link_speed")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] &&
                  results.data.subtests[subtest].linkspeed + "b/s"}
              </Typography>
            </Grid>
          </Grid>
        );
    }
  }
}

export default withStyles(styles)(TracerouteSubtest);
